import styled from 'styled-components'

const DialogUlStyle = styled.ul`
  margin: 0;
  padding: 0 18px;
  color: ${props => props.theme.black60};
`

export default DialogUlStyle
